var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UserType } from "healthex-common/user.dtos";
import { computed, observable } from "mobx";
import { NOT_LOADED } from "../../Infra/RemoteData";
import { NamedRoutes } from "../NamedRoutes";
export class GlobalAdminGlobalOrganizationListViewModel {
    constructor(container) {
        this.latestHealthCheckRuns = NOT_LOADED;
        this.isRunningHealthCheck = false;
        this.expandedTestRunIndex = null;
        this.routingUIManager = container.routingUIManager;
        this.organizationsManager = container.organizationsManager;
        this.iasHealthCheckService = container.iasHealthCheckService;
        void this.loadLatestHealthChecks();
    }
    async loadLatestHealthChecks() {
        try {
            const results = await this.iasHealthCheckService.getLatestHealthChecks();
            this.latestHealthCheckRuns = results;
        }
        catch (error) {
            console.error("Failed to load health check runs:", error);
            this.latestHealthCheckRuns = [];
        }
    }
    get healthcareOrganizations() {
        var _a;
        if (this.organizationsManager.organizations.value === NOT_LOADED)
            return NOT_LOADED;
        return (_a = this.organizationsManager.organizations.value) === null || _a === void 0 ? void 0 : _a.filter((organization) => organization.type === UserType.HEALTHCARE_ORGANIZATION);
    }
    get externalResearcherOrganizations() {
        var _a;
        if (this.organizationsManager.organizations.value === NOT_LOADED)
            return NOT_LOADED;
        return (_a = this.organizationsManager.organizations.value) === null || _a === void 0 ? void 0 : _a.filter((organization) => organization.type === UserType.EXTERNAL_RESEARCHER);
    }
    get serviceProviderOrganizations() {
        var _a;
        if (this.organizationsManager.organizations.value === NOT_LOADED)
            return NOT_LOADED;
        return (_a = this.organizationsManager.organizations.value) === null || _a === void 0 ? void 0 : _a.filter((organization) => organization.type === UserType.SERVICE_PROVIDER);
    }
    createNewHealthcareOrganization() {
        this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_CREATE);
    }
    viewHealthcareOrganizationDetails(organization) {
        this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_DETAIL, { orgId: organization.id });
    }
    createExternalResearcherOrganization() {
        this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_ORG_DATA_USER_CREATE);
    }
    viewExternalResearcherOrganizationDetails(organization) {
        this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_ORG_DATA_USER_DETAIL, { orgId: organization.id });
    }
    viewServiceProviderOrganizationDetails(organization) {
        this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_ORG_SERVICE_PROVIDER_DETAIL, { orgId: organization.id });
    }
    async runHealthCheck() {
        this.isRunningHealthCheck = true;
        try {
            await this.iasHealthCheckService.runHealthCheck();
            await this.loadLatestHealthChecks();
        }
        catch (error) {
            console.error("Failed to run health check:", error);
        }
        finally {
            this.isRunningHealthCheck = false;
        }
    }
    async refreshHealthCheckResults() {
        await this.loadLatestHealthChecks();
    }
    toggleTestRunDetails(index) {
        this.expandedTestRunIndex = this.expandedTestRunIndex === index ? null : index;
    }
    getPatientStatusIcon(patient) {
        const notFound = !patient.foundInPatientMapping;
        const hasError = patient.errorMessages.some((e) => !e.includes("not found"));
        return hasError ? "❌" : notFound ? "⚠️" : "✅";
    }
    getSortedPatients(result) {
        return [...result.patientTrackingResults].sort((a, b) => {
            var _a, _b;
            const nameA = (_a = a.patientName) !== null && _a !== void 0 ? _a : a.phoneNumber;
            const nameB = (_b = b.patientName) !== null && _b !== void 0 ? _b : b.phoneNumber;
            return nameA.localeCompare(nameB);
        });
    }
    getPatientsNotFound(result) {
        return result.summary.totalSandboxUsers - result.summary.patientsFound;
    }
    formatTestDate(createdAt) {
        const testDate = new Date(createdAt);
        const today = new Date();
        const isToday = testDate.toDateString() === today.toDateString();
        if (isToday) {
            return testDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
        }
        else {
            return testDate.toLocaleDateString();
        }
    }
    getPatientComment(patient) {
        if (patient.errorMessages.length === 0) {
            return "-";
        }
        if (patient.errorMessages.some((e) => e.includes("not found in mapping table"))) {
            return "Not found in mapping";
        }
        if (patient.errorMessages.some((e) => e.includes("No refresh token"))) {
            return "No refresh token";
        }
        if (patient.errorMessages.some((e) => e.includes("Failed to refresh"))) {
            return "Token refresh failed";
        }
        if (patient.errorMessages.some((e) => e.includes("Failed to add patient to MedAllies"))) {
            return "MedAllies add failed";
        }
        if (patient.errorMessages.some((e) => e.includes("Error getting documents"))) {
            return "Document retrieval failed";
        }
        return patient.errorMessages[0];
    }
}
__decorate([
    observable
], GlobalAdminGlobalOrganizationListViewModel.prototype, "latestHealthCheckRuns", void 0);
__decorate([
    observable
], GlobalAdminGlobalOrganizationListViewModel.prototype, "isRunningHealthCheck", void 0);
__decorate([
    observable
], GlobalAdminGlobalOrganizationListViewModel.prototype, "expandedTestRunIndex", void 0);
__decorate([
    computed
], GlobalAdminGlobalOrganizationListViewModel.prototype, "healthcareOrganizations", null);
__decorate([
    computed
], GlobalAdminGlobalOrganizationListViewModel.prototype, "externalResearcherOrganizations", null);
__decorate([
    computed
], GlobalAdminGlobalOrganizationListViewModel.prototype, "serviceProviderOrganizations", null);
